
/**
 * Interface for adding and removing search results to the recent searches set
 * @param {} $rootScope 
 * @param {} storageService 
 * @param {} $constants 
 * @returns {} 
 */
export default function ($rootScope, storageService, timetableConfig) {

    var recent = storageService.getRecent();

    /**
     * Emit the change event, this is available for subscription via timetableservice.subscribe()
     * @returns {} 
     */
    function notify() {
        $rootScope.$emit('recentChanged', recent);
    }

    /**
     * Add a course, class or search term to the recently viewed array
     * @param {} c 
     * @returns {} 
     */
    function add(c) {

        var found = recent.where(function (el) {
            return el.courseCode === c.courseCode || c.courseCode === el.fullDescription;
        }).length;

        if (!found && recent.length) {
            if (recent.length + 1 > timetableConfig.SIDEBAR_MAX) {
                recent.splice(recent.length - 1, 1);
            }

            recent.splice(0, 0, c);
        } else if (!recent.length) {
            recent[0] = c;
        } else if (found) {

            var index = recent.findIndex(function (el) {
                return el.courseCode === c.courseCode || c.courseCode === el.fullDescription;
            });

            recent.splice(0, 0, recent.splice(index, 1)[0]);
        }

        // store it, then tell the world
        storageService.storeRecent(recent);
        notify();
    }

    /**
     * Remove the selected item from the recent searches object, then update stored version
     * @param {} $event 
     * @param {} index 
     * @returns {} 
     */
    function remove(c) {

        var index = recent.findIndex(function (el) {
            return el.courseCode === c.courseCode || c.courseCode === el.fullDescription;
        });

        recent.splice(index, 1);

        storageService.storeRecent(recent);
        notify();
    };

    return {
        add: add,
        remove: remove
    }
};